import { getRootEnv } from '@bringg-frontend/bringg-web-infra';
import { action, makeObservable } from 'mobx';

import ActionsConfiguration, { normalizeActionsConfiguration } from './actions-configuration';
import {
	ActionsConfigurationLevel,
	ActionsConfiguration as ActionsConfigurationEntity
} from '../../../types/common.consts';

export default class InventoryActionsConfiguration extends ActionsConfiguration {
	constructor(actionsConfiguration: ActionsConfigurationEntity) {
		super(actionsConfiguration);
		// Assigned, not a class field: the base already made `level` a non-configurable MobX
		// observable, and a field initializer would Object.defineProperty over it and throw.
		this.level = ActionsConfigurationLevel.INVENTORY;

		makeObservable(this, {
			delete: action
		});
	}

	update = () => {
		const updateParams = {
			title: this.title,
			action_data: normalizeActionsConfiguration(this.action_data, this.level)
		};
		return getRootEnv().dashboardSdk.sdk.inventoryActionsConfigurations.update(this.id, updateParams);
	};

	delete = () => {
		return getRootEnv().dashboardSdk.sdk.inventoryActionsConfigurations.delete(this.id);
	};
}
